export default __webpack_public_path__ + "0203923317c20c968e1fdc7f8789eec4.png";